module.exports = __webpack_public_path__ + "img/tabor.21768a40.jpg";